import React from 'react';
import { VideoLandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingVideoBackgroundRemoverConfig } from '@/data/landingConfig/landingVideoBackgroundRemoverConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_VideoBackgroundRemover } from './schemaObject';

interface Props {}
const VideoBackgroundRemover: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_VideoBackgroundRemover} />
			<VideoLandingTemplate
				data={landingVideoBackgroundRemoverConfig}
				funnelLinkService={GenerateLandingLinkService.funnelVideoBackgroundRemover()}
			/>
		</>
	);
};

export default VideoBackgroundRemover;
